import { render, staticRenderFns } from "./ReleaseNoteDirectCopy.vue?vue&type=template&id=3e1591b8"
import script from "./ReleaseNoteDirectCopy.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteDirectCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports